import { getContext, takeLatest } from 'redux-saga/effects';
import { sagaTaskDescriptor } from 'data';
import { setQueryClientAction } from '../actions';
export const getQueryClientContext = function*() {
    return yield getContext('queryClient');
};
function setQueryClientContext({ payload }) {
    sagaTaskDescriptor.setContext({
        queryClient: payload
    });
}
export const watchQueryClientSaga = function*() {
    yield takeLatest(setQueryClientAction.type, setQueryClientContext);
};
